import type { BlogPost } from './types'

export const post: BlogPost = {
  slug: 'booking-page-readiness-checklist',
  title: 'A Booking Page Readiness Checklist for Solo Mobile Operators',
  excerpt:
    'Before sharing a booking link, mobile operators should confirm business basics, service areas, hours, services, billing, and customer messaging.',
  content: `
A public booking page is a storefront. For a mobile service provider, it is also an operations promise.

Before sharing the link, operators should make sure the page has enough configuration to produce bookings they can actually fulfill.

## 1. Business basics

Customers need to recognize who they are booking with. Confirm the business name, public slug, phone number, timezone, and any short bio or branding details that make the page feel legitimate.

## 2. Service area

The service area is not a cosmetic setting. It decides which customer addresses can move forward.

Check:

- The center address is correct.
- Radius rules match how far you are willing to travel.
- Postal-code inclusions or exclusions reflect your real policy.
- Any surcharge or drive-time constraints are intentional.

## 3. Hours and locations

Weekly hours define the first layer of availability. Day start and end locations define the travel context around those hours.

If a day starts from home and ends near a school pickup, the booking system should know that before it offers appointments.

## 4. Services

Every public service should have a clear name, duration, active state, and price. If intake questions are needed, add them before sending the page to customers.

## 5. Launch and billing

Use private or preview states while testing. Go live only when billing, trial, or card-on-file rules match the way you plan to charge for bookings.

## 6. Customer messaging

Run one test booking from a customer perspective. Confirm the OTP step, confirmation page, confirmation email, and manage-booking link all make sense.

## A better launch is a quieter calendar

The goal is not to configure every possible feature. The goal is to make the public page trustworthy enough that a customer can book without creating manual cleanup for the operator.
  `,
  author: {
    name: 'Zippity',
  },
  date: '2026-04-11',
  readTime: '5 min read',
  tags: ['setup', 'booking-page', 'readiness', 'mobile-services'],
}
